import {
  ActionType,
  BudgetType,
  RunningPattern,
  SelectPattern,
} from 'core/rtbCampaign/singlePage/common';
import { useEffect, useState } from 'react';

interface OutboundModeState {
  disabled: boolean;
  disabledText: string;
}

export const useOutboundState = (
  mode: 'runningPattern' | 'budget' | 'productSelection' = 'runningPattern',
  actionType: ActionType,
  defaultOutboundInfo?: {
    brandNo: string;
  },
  options?: {
    brandOptions?: any[];
    selectPattern?: SelectPattern;
    runningPattern?: RunningPattern;
    budgetType?: BudgetType;
  },
): OutboundModeState => {
  const [disabledText, setDisabledText] = useState<string>('');
  const [isDisabled, setIsDisabled] = useState<boolean>(
    !!defaultOutboundInfo?.brandNo,
  );

  useEffect(() => {
    if (isDisabled) {
      switch (mode) {
        case 'runningPattern':
          if (
            actionType === ActionType.EDIT &&
            options?.runningPattern === RunningPattern.LIMITED
          )
            setDisabledText(
              '您已開啟過momo聯播網，不支持切換為無限制走期，若需調整請重新建立廣告活動',
            );
          else setIsDisabled(false);
          break;
        case 'budget':
          if (
            options?.budgetType === BudgetType.TOTAL &&
            actionType === ActionType.EDIT
          ) {
            setDisabledText(
              '您已開啟過momo聯播網，不支持切換為每日預算模式，若需調整請重新建立廣告活動',
            );
          } else if (
            options?.budgetType === BudgetType.DAILY &&
            actionType === ActionType.EDIT
          ) {
            setDisabledText(
              '您已開啟過momo聯播網，不支持切換為總預算模式，若需調整請重新建立廣告活動',
            );
          } else setIsDisabled(false);
          break;
        case 'productSelection':
          const { brandOptions = [], selectPattern } = options || {};
          if (
            selectPattern === SelectPattern.MANUAL &&
            actionType === ActionType.EDIT
          ) {
            setDisabledText(
              '您已開啟momo聯播網，不可切換為智能選品，若需調整請重新建立廣告活動',
            );
            return;
          } else {
            setIsDisabled(false);
          }

          if (
            brandOptions.length === 1 &&
            (brandOptions[0].value === '1' ||
              brandOptions[0].value === '99999999999999999')
          ) {
            setDisabledText('動態調整投廣商品(此功能僅限部分廣告主)');
            return;
          }
          break;

        default:
          setDisabledText('動態調整投廣商品(此功能僅限部分廣告主)');
      }
    } else {
      switch (mode) {
        case 'runningPattern':
          return;
        case 'productSelection':
          const { brandOptions = [], selectPattern } = options || {};
          if (selectPattern === SelectPattern.MANUAL) {
            if (
              brandOptions.length === 1 &&
              (brandOptions[0].value === '1' ||
                brandOptions[0].value === '99999999999999999')
            ) {
              setIsDisabled(true);
              setDisabledText('動態調整投廣商品(此功能僅限部分廣告主)');
              return;
            }
            return;
          }
          break;
        default:
          setDisabledText('動態調整投廣商品(此功能僅限部分廣告主)');
      }
    }
  }, [
    defaultOutboundInfo,
    mode,
    options?.brandOptions,
    options?.selectPattern,
  ]);

  return { disabled: isDisabled, disabledText: disabledText };
};
